import React, { useRef, useEffect, useState } from 'react';
import Webcam from 'react-webcam';
import {
  getVideoConstraints,
  detectAvailableCameras
} from '../../helpers/cameraUtils';

const AdminVideo = () => {
  const webcamRef = useRef(null);
  const [videoConstraints, setVideoConstraints] = useState({
    width: 150,
    height: 100,
    facingMode: 'user'
  });
  const [cameraError, setCameraError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedCamera, setSelectedCamera] = useState('user');

  useEffect(() => {
    // Initialize camera detection and set constraints
    const initializeCamera = async () => {
      try {
        const constraints = getVideoConstraints(null, {
          width: 150,
          height: 100
        });
        console.log('AdminVideo - videoConstraints:', constraints);
        console.log(
          'AdminVideo - selectedCamera:',
          localStorage.getItem('selectedCamera')
        );
        setVideoConstraints(constraints);

        // Also detect available cameras
        const cameras = await detectAvailableCameras();
        console.log('AdminVideo - available cameras:', cameras);
        setIsLoading(false);
      } catch (error) {
        console.error('AdminVideo - Error initializing camera:', error);
        setCameraError(error.message);
        // Fallback to basic constraints
        setVideoConstraints({
          width: 150,
          height: 100,
          facingMode: 'user'
        });
        setIsLoading(false);
      }
    };

    initializeCamera();
  }, []);

  // Listen for localStorage changes to update camera in real-time
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'selectedCamera' && e.newValue !== selectedCamera) {
        console.log('AdminVideo - Camera selection changed:', e.newValue);
        setSelectedCamera(e.newValue);

        // Update video constraints
        const constraints = getVideoConstraints(null, {
          width: 150,
          height: 100
        });

        console.log('AdminVideo - Updated videoConstraints:', constraints);
        setVideoConstraints(constraints);
        setCameraError(null); // Clear any previous errors
      }
    };

    // Listen for storage events (works across tabs)
    window.addEventListener('storage', handleStorageChange);

    // Also listen for custom camera change events (same tab)
    const handleCameraChange = (e) => {
      console.log('AdminVideo - Custom camera change event:', e.detail);
      if (e.detail && e.detail.selectedCamera !== selectedCamera) {
        setSelectedCamera(e.detail.selectedCamera);

        const constraints = getVideoConstraints(null, {
          width: 150,
          height: 100
        });

        console.log(
          'AdminVideo - Updated videoConstraints from custom event:',
          constraints
        );
        setVideoConstraints(constraints);
        setCameraError(null);
      }
    };

    window.addEventListener('cameraSelectionChanged', handleCameraChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('cameraSelectionChanged', handleCameraChange);
    };
  }, [selectedCamera]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        zIndex: 1,
        position: 'absolute',
        width: '100%',
        padding: '12px',
        borderRadius: '10px'
      }}
    >
      {isLoading ? (
        <div
          style={{
            width: 150,
            height: 100,
            backgroundColor: '#f0f0f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
        >
          <span style={{ fontSize: '12px', color: '#666' }}>
            Loading camera...
          </span>
        </div>
      ) : cameraError ? (
        <div
          style={{
            width: 150,
            height: 100,
            backgroundColor: '#ffebee',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
            border: '1px solid #f44336'
          }}
        >
          <span
            style={{ fontSize: '10px', color: '#d32f2f', textAlign: 'center' }}
          >
            Camera Error
          </span>
        </div>
      ) : (
        <Webcam
          id="vid"
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/png"
          videoConstraints={videoConstraints}
          onUserMedia={(stream) => {
            console.log('AdminVideo - Camera stream started:', stream);
            setCameraError(null);
          }}
          onUserMediaError={(error) => {
            console.error('AdminVideo - Camera error:', error);
            setCameraError(error.message);
          }}
        />
      )}
    </div>
  );
};

export default AdminVideo;
